import React from "react";
import { format } from "date-fns";

import { Chip } from "@mui/material";

import BatchDetail from "../../../common/BatchDetail";
import ColumnHeader from "../../../common/ColumnHeader";
import { CLIENTS, getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";
import { __getActivate } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "msisdn", "extra_data.imei", "last_updated"];

const activateColumns = ({ handleColumnClick, client }) => [
  { field: "id", headerName: "ID", flex: 1, sortable: false },
  {
    field: "iccid",
    headerName: "ICCID",
    minWidth: 200,
    flex: 3,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="ICCID" handleClick={() => handleColumnClick("iccid")} />
      ) : (
        "ICCID"
      ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 120,
    flex: 2,
    sortable: false,
    renderCell: (params) => (
      <Chip label={params.row.status} size="small" color={getChipColor(params.row.status)} />
    ),
  },
  {
    field: "trial_count",
    headerName: "Trials",
    minWidth: 50,
    flex: 1,
    sortable: false,
    renderCell: (params) => <Chip label={`${params.row.trial_count}`} size="small" color="default" />,
  },
  {
    field: "msisdn",
    headerName: "MSISDN",
    minWidth: 100,
    flex: 2,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="MSISDN" handleClick={() => handleColumnClick("msisdn")} />
      ) : (
        "MSISDN"
      ),
  },
  {
    field: "extra_data",
    headerName: "IMEI",
    minWidth: 100,
    flex: 2,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="IMEI" handleClick={() => handleColumnClick("extra_data.imei")} />
      ) : (
        "IMEI"
      ),
    valueGetter: (params) => params.row.extra_data?.imei,
  },
  {
    field: "zipcode",
    headerName: "Zipcode",
    flex: 2,
    sortable: false,
    valueGetter: (params) => params.row.zipcode || params.row.extra_data?.zipcode,
  },
  {
    field: "created_at",
    headerName: "Created At",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.created_at || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
  {
    field: "last_updated",
    headerName: "Last Updated",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.last_updated || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
];

// Retry and Check Status were commented-out (dead) in the original page - only
// Export/Copy/Terminate were actually live.
const TMobileActivateBatch = () => (
  <BatchDetail
    title="T-Mobile Activate"
    apiGet={__getActivate}
    client={CLIENTS.tmobile}
    columnsFactory={activateColumns}
    copyKeys={COPY_KEYS}
    exportAction="activate"
    showTerminate
    getRowPath={(row) => `/tmobile/activate/${row.id}`}
  />
);

export default TMobileActivateBatch;
